const conf = {
  "enemy": [
    "Terminid",
    "Automaton",
    "Illuminate"
  ],
  "difficulty": [
    "1 - Trivial or greater",
    "2 - Easy or greater",
    "3 - Medium or greater",
    "4 - Challenging or greater",
    "5 - Hard or greater",
    "6 - Extreme or greater",
    "7 - Suicide Mission or greater",
    "8 - Impossible or greater",
    "9 - Helldive or greater",
    "10 - Super Helldive"
  ],
  "difficultyWeights": [
    0.0200000000, // "1 - Trivial or greater"
    0.0700000000, // "2 - Easy or greater"
    0.0700000000, // "3 - Medium or greater"
    0.1200000000, // "4 - Challenging or greater"
    0.1200000000, // "5 - Hard or greater"
    0.1200000000, // "6 - Extreme or greater"
    0.1200000000, // "7 - Suicide Mission or greater"
    0.1200000000, // "8 - Impossible or greater"
    0.1200000000, // "9 - Helldive or greater"
    0.1200000000, // "10 - Super Helldive"
  ],
  "duration": [
    "10 minute or more",
    "12 minute or more",
    "15 minute or more",
    "20 minute or more",
    "40 minute"
  ],
  "durationWeights": [
    0.0500000000, // "10 minute or more"
    0.0500000000, // "12 minute or more"
    0.0500000000, // "15 minute or more"
    0.0500000000, // "20 minute or more"
    0.8000000000, // "40 minute"
  ],
  "teamplay": [
    "Solo",
    "Squad"
  ],
  "teamplayWeights": [
    0.2000000000, // "Solo"
    0.8000000000, // "Squad"
  ],
  "stars": [
    "0 stars or more",
    "1 stars or more",
    "2 stars or more",
    "3 stars or more",
    "4 stars or more",
    "5 stars"
  ],
  "primary": [
    "AR-23 Liberator",
    "AR-23A Liberator Carbine",
    "AR-23C Liberator Concussive",
    "AR-23P Liberator Penetrator",
    "AR-61 Tenderizer",
    "ARC-12 Blitzer",
    "BR-14 Adjudicator",
    "CB-9 Exploding Crossbow",
    "FLAM-66 Torcher",
    "JAR-5 Dominator",
    "LAS-16 Sickle",
    "LAS-5 Scythe",
    "MP-98 Knight",
    "Plas-1 Scorcher",
    "Plas-101 Purifier",
    "R-2124 Constitution",
    "R-36 Eruptor",
    "R-63 Diligence",
    "R-63CS Diligence Counter Sniper",
    "SG-20 Halt",
    "SG-225 Breaker",
    "SG-225IE Breaker Incendiary",
    "SG-225SP Breaker SPRAY&PRAY",
    "SG-451 Cookout",
    "SG-8 Punisher",
    "SG-8P Punisher Plasma",
    "SG-8S Slugger",
    "SMG-32 Reprimand",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-52 Assault Rifle",
    "StA-11 SMG",
    "PLAS-39 Accelerator Rifle",
    "LAS-17 Double-Edge Sickle",
    "R-6 Deadeye",
    "R-2 Amendment",
    "AR-32 Pacifier",
    "VG-70 Variable",
    "MA5C Assault Rifle",
    "M7S SMG",
    "M90A Shotgun",
    "AR-2 Coyote",
    "AR/GL-21 One-Two",
    "DBS-2 Double Freedom",
    "R-72 Censor",
    "AR-59 Suppressor",
    "LAS-16 Trident",
    "SMG/FLAM-34 Stoker",
    "SG-225SP Sweeper",
    "SMG-203 Gallant",
    "R-4 Hyena",
  ],
  "primaryWeights": [
    0.0203498960, // "AR-23 Liberator"
    0.0204909233, // "AR-23A Liberator Carbine"
    0.0191263131, // "AR-23C Liberator Concussive"
    0.0172528620, // "AR-23P Liberator Penetrator"
    0.0197969720, // "AR-61 Tenderizer"
    0.0197455913, // "ARC-12 Blitzer"
    0.0203552824, // "BR-14 Adjudicator"
    0.0141485982, // "CB-9 Exploding Crossbow"
    0.0194032940, // "FLAM-66 Torcher"
    0.0183119279, // "JAR-5 Dominator"
    0.0210970336, // "LAS-16 Sickle"
    0.0189492405, // "LAS-5 Scythe"
    0.0201739288, // "MP-98 Knight"
    0.0205020210, // "Plas-1 Scorcher"
    0.0186305124, // "Plas-101 Purifier"
    0.0204889660, // "R-2124 Constitution"
    0.0141585963, // "R-36 Eruptor"
    0.0191896776, // "R-63 Diligence"
    0.0201253032, // "R-63CS Diligence Counter Sniper"
    0.0209537257, // "SG-20 Halt"
    0.0217690777, // "SG-225 Breaker"
    0.0192435430, // "SG-225IE Breaker Incendiary"
    0.0189180405, // "SG-225SP Breaker SPRAY&PRAY"
    0.0201528749, // "SG-451 Cookout"
    0.0201389058, // "SG-8 Punisher"
    0.0176908516, // "SG-8P Punisher Plasma"
    0.0193394851, // "SG-8S Slugger"
    0.0198766349, // "SMG-32 Reprimand"
    0.0204026406, // "SMG-37 Defender"
    0.0213861972, // "SMG-72 Pummeler"
    0.0197358483, // "StA-52 Assault Rifle"
    0.0196686770, // "StA-11 SMG"
    0.0208749291, // "PLAS-39 Accelerator Rifle"
    0.0200178694, // "LAS-17 Double-Edge Sickle"
    0.0190334946, // "R-6 Deadeye"
    0.0213546879, // "R-2 Amendment"
    0.0188853353, // "AR-32 Pacifier"
    0.0199867429, // "VG-70 Variable"
    0.0199148602, // "MA5C Assault Rifle"
    0.0203094168, // "M7S SMG"
    0.0188801326, // "M90A Shotgun"
    0.0198348061, // "AR-2 Coyote"
    0.0196292830, // "AR/GL-21 One-Two"
    0.0192266671, // "DBS-2 Double Freedom"
    0.0221179672, // "R-72 Censor"
    0.0195685053, // "AR-59 Suppressor"
    0.0190435078, // "LAS-16 Trident"
    0.0194000413, // "SMG/FLAM-34 Stoker"
    0.0206772281, // "SG-225SP Sweeper"
    0.0200632402, // "SMG-203 Gallant"
    0.0196078431, // "R-4 Hyena"
  ],
  "secondary": [
    "GP-31 Grenade Pistol",
    "LAS-7 Dagger",
    "P-2 Peacemaker",
    "P-4 Senator",
    "P-11 Stim Pistol",
    "P-19 Redeemer",
    "P-72 Crisper",
    "P-113 Verdict",
    "PLAS-15 Loyalist",
    "SG-22 Bushwhacker",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "GP-31 Ultimatum",
    "LAS-58 Talon",
    "CQC-2 Saber",
    "P-92 Warrant",
    "M6C/SOCOM Pistol",
    "CQC-42 Machete",
    "P-35 Re-Educator",
    "CQC-73 Entrenchment Tool",
    "P-69 Veto",
    "P-33 Missile Pistol",
  ],
  "secondaryWeights": [
    0.0339422366, // "GP-31 Grenade Pistol"
    0.0435351781, // "LAS-7 Dagger"
    0.0438256373, // "P-2 Peacemaker"
    0.0407765318, // "P-4 Senator"
    0.0522731578, // "P-11 Stim Pistol"
    0.0445799122, // "P-19 Redeemer"
    0.0413789623, // "P-72 Crisper"
    0.0468230777, // "P-113 Verdict"
    0.0455524131, // "PLAS-15 Loyalist"
    0.0439317985, // "SG-22 Bushwhacker"
    0.0437226669, // "CQC-19 Stun Lance"
    0.0431991510, // "CQC-30 Stun Baton"
    0.0429502314, // "CQC-5 Combat Hatchet"
    0.0440789389, // "GP-31 Ultimatum"
    0.0414088606, // "LAS-58 Talon"
    0.0478058686, // "CQC-2 Saber"
    0.0427597898, // "P-92 Warrant"
    0.0452851650, // "M6C/SOCOM Pistol"
    0.0481961300, // "CQC-42 Machete"
    0.0422631947, // "P-35 Re-Educator"
    0.0449988871, // "CQC-73 Entrenchment Tool"
    0.0476352972, // "P-69 Veto"
    0.0290769131, // "P-33 Missile Pistol"
  ],
  "grenade": [
    "G-3 Smoke",
    "G-4 Gas Grenade",
    "G-6 Frag",
    "G-10 Incendiary",
    "G-12 High Explosive",
    "G-13 Incendiary Impact",
    "G-16 Impact",
    "G-23 Stun",
    "G-123 Thermite",
    "K-2 Throwing Knife",
    "G-50 Seeker",
    "TED-63 Dynamite",
    "G-142 Pyrotech",
    "G-109 Urchin",
    "G-31 Arc",
    "G-7 Pineapple",
    "TM-1 Lure Mine",
    "G/SH-39 Shield",
    "G-89 Smokescreen",
    "G-48 Giga Grenade",
  ],
  "grenadeWeights": [
    0.0622971121, // "G-3 Smoke"
    0.0649475771, // "G-4 Gas Grenade"
    0.0363401031, // "G-6 Frag"
    0.0329307013, // "G-10 Incendiary"
    0.0368038620, // "G-12 High Explosive"
    0.0344754193, // "G-13 Incendiary Impact"
    0.0376571860, // "G-16 Impact"
    0.0623542277, // "G-23 Stun"
    0.0349748648, // "G-123 Thermite"
    0.0643187923, // "K-2 Throwing Knife"
    0.0682333568, // "G-50 Seeker"
    0.0360223526, // "TED-63 Dynamite"
    0.0363078691, // "G-142 Pyrotech"
    0.0625210917, // "G-109 Urchin"
    0.0660262387, // "G-31 Arc"
    0.0365297323, // "G-7 Pineapple"
    0.0635949481, // "TM-1 Lure Mine"
    0.0658277417, // "G/SH-39 Shield"
    0.0630289329, // "G-89 Smokescreen"
    0.0348078905, // "G-48 Giga Grenade"
  ],
  "stratagem": [
    "A/AC-8 Autocannon Sentry",
    "A/ARC-3 Tesla Tower",
    "A/G-16 Gatling Sentry",
    "A/M-12 Mortar Sentry",
    "A/M-23 EMS Mortar Sentry",
    "A/MG-43 Machine Gun Sentry",
    "A/MLS-4X Rocket Sentry",
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "E/MG-101 HMG Emplacement",
    "Eagle 110m Rocket Pods",
    "Eagle 500kg Bomb",
    "Eagle Airstrike",
    "Eagle Cluster Bomb",
    "Eagle Napalm Airstrike",
    "Eagle Smoke Strike",
    "Eagle Strafing Run",
    "EAT-17 Expendable Anti-Tank",
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "FX-12 Shield Generator Relay",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "LIFT-850 Jump Pack",
    "M-105 Stalwart",
    "MD-6 Anti-Personnel Minefield",
    "MD-17 Anti-Tank Mines",
    "MD-I4 Incendiary Mines",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "Orbital 120MM HE Barrage",
    "Orbital 380MM HE Barrage",
    "Orbital Airburst Strike",
    "Orbital EMS Strike",
    "Orbital Gas Strike",
    "Orbital Gatling Barage",
    "Orbital Laser",
    "Orbital Napalm Barrage",
    "Orbital Precision Strike",
    "Orbital Railcannon Strike",
    "Orbital Smoke Strike",
    "Orbital Walking Barrage",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "TX-41 Sterilizer",
    "SH-51 Directional Shield",
    "A/FLAM-40 Flame Sentry",
    "E/AT-12 Anti-Tank Emplacement",
    "M-102 Fast Recon Vehicle",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "MD-8 Gas Mines",
    "LIFT-860 Hover Pack",
    "E/GL-21 Grenadier Battlement",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "AX/ARC-3 Guard Dog K-9",
    "Plas-45 Epoch",
    "A/LAS-98 Laser Sentry",
    "LIFT-182 Warp Pack",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "M-1000 Maxigun",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "TD-220 Bastion MK XVI",
    "A/GM-17 Gas Mortar Sentry",
    "B/FLAM-80 Cremator",
    "MGX-42 Bullet Storm",
    "EXO-51 Lumberer Exosuit",
    "EXO-55 Breakthrough Exosuit",
    "M-103 Supply FRV",
  ],
  "stratagemWeights": [
    0.0089984135, // "A/AC-8 Autocannon Sentry"
    0.0090446144, // "A/ARC-3 Tesla Tower"
    0.0091961816, // "A/G-16 Gatling Sentry"
    0.0089470511, // "A/M-12 Mortar Sentry"
    0.0088475092, // "A/M-23 EMS Mortar Sentry"
    0.0089042615, // "A/MG-43 Machine Gun Sentry"
    0.0084525449, // "A/MLS-4X Rocket Sentry"
    0.0000000001, // "AC-8 Autocannon"
    0.0000000001, // "APW-1 Anti-Material Rifle"
    0.0000000001, // "ARC-3 Arc Thrower"
    0.0436193569, // "AX/AR-23 Guard Dog"
    0.0443583901, // "AX/TX-13 Guard Dog Dog Breath"
    0.0413191488, // "AX/LAS-5 Guard Dog Rover"
    0.0471289453, // "B-1 Supply Pack"
    0.0091270479, // "E/MG-101 HMG Emplacement"
    0.0084467903, // "Eagle 110m Rocket Pods"
    0.0084109423, // "Eagle 500kg Bomb"
    0.0086121208, // "Eagle Airstrike"
    0.0087304176, // "Eagle Cluster Bomb"
    0.0084403548, // "Eagle Napalm Airstrike"
    0.0100737645, // "Eagle Smoke Strike"
    0.0081755822, // "Eagle Strafing Run"
    0.0000000001, // "EAT-17 Expendable Anti-Tank"
    0.0079591220, // "EXO-45 Patriot Exosuit"
    0.0077311714, // "EXO-49 Emancipator Exosuit"
    0.0000000001, // "FAF-14 Spear"
    0.0000000001, // "FLAM-40 Flamethrower"
    0.0454248900, // "FX-12 Shield Generator Relay"
    0.0000000001, // "GL-21 Grenade Launcher"
    0.0000000001, // "GR-8 Recoilless Rifle"
    0.0000000001, // "LAS-98 Laser Cannon"
    0.0000000001, // "LAS-99 Quasar Cannon"
    0.0428607235, // "LIFT-850 Jump Pack"
    0.0000000001, // "M-105 Stalwart"
    0.0087065976, // "MD-6 Anti-Personnel Minefield"
    0.0095863399, // "MD-17 Anti-Tank Mines"
    0.0092097351, // "MD-I4 Incendiary Mines"
    0.0000000001, // "MG-206 Heavy Machine Gun"
    0.0000000001, // "MG-43 Machine Gun"
    0.0000000001, // "MLS-4X Commando"
    0.0081257611, // "Orbital 120MM HE Barrage"
    0.0081633269, // "Orbital 380MM HE Barrage"
    0.0089478835, // "Orbital Airburst Strike"
    0.0090034720, // "Orbital EMS Strike"
    0.0088360457, // "Orbital Gas Strike"
    0.0090377120, // "Orbital Gatling Barage"
    0.0093017378, // "Orbital Laser"
    0.0086163518, // "Orbital Napalm Barrage"
    0.0089481582, // "Orbital Precision Strike"
    0.0095598839, // "Orbital Railcannon Strike"
    0.0106060545, // "Orbital Smoke Strike"
    0.0081108987, // "Orbital Walking Barrage"
    0.0000000001, // "RL-77 Airburst Rocket Launcher"
    0.0000000001, // "RS-422 Railgun"
    0.0442025758, // "SH-20 Balistic Shield Backpack"
    0.0430769826, // "SH-32 Shield Generator Pack"
    0.0000000001, // "TX-41 Sterilizer"
    0.0456392873, // "SH-51 Directional Shield"
    0.0092355483, // "A/FLAM-40 Flame Sentry"
    0.0091453733, // "E/AT-12 Anti-Tank Emplacement"
    0.0092006522, // "M-102 Fast Recon Vehicle"
    0.0000000001, // "StA-X3 W.A.S.P. Launcher"
    0.0442964976, // "B-100 Portable Hellbomb"
    0.0086066620, // "MD-8 Gas Mines"
    0.0425662784, // "LIFT-860 Hover Pack"
    0.0089667738, // "E/GL-21 Grenadier Battlement"
    0.0000000001, // "CQC-1 One True Flag"
    0.0000000001, // "GL-52 De-Escalator"
    0.0434744331, // "AX/ARC-3 Guard Dog K-9"
    0.0000000001, // "Plas-45 Epoch"
    0.0094812268, // "A/LAS-98 Laser Sentry"
    0.0426750869, // "LIFT-182 Warp Pack"
    0.0000000001, // "MS-11 Solo Silo"
    0.0000000001, // "EAT-700 Expendable Napalm"
    0.0000000001, // "S-11 Speargun"
    0.0000000001, // "CQC-9 Defoliation Tool"
    0.0469292301, // "AZ/FLAM-75 Guard Dog Hot Dog"
    0.0000000001, // "M-1000 Maxigun"
    0.0000000001, // "B/MD C4 Pack"
    0.0000000001, // "GL-28 Belt-Fed Grenade Launcher"
    0.0000000001, // "EAT-411 Leveller"
    0.0000000001, // "CQC-20 Breaching Hammer"
    0.0096434714, // "TD-220 Bastion MK XVI"
    0.0089458134, // "A/GM-17 Gas Mortar Sentry"
    0.0000000001, // "B/FLAM-80 Cremator"
    0.0000000001, // "MGX-42 Bullet Storm"
    0.0080048708, // "EXO-51 Lumberer Exosuit"
    0.0081643549, // "EXO-55 Breakthrough Exosuit"
    0.0101755733, // "M-103 Supply FRV"
  ],
  "supportStratagemWeights": [
    0.0223979046, // "AC-8 Autocannon"
    0.0379022504, // "APW-1 Anti-Material Rifle"
    0.0366868314, // "ARC-3 Arc Thrower"
    0.0286078763, // "EAT-17 Expendable Anti-Tank"
    0.0317885188, // "FAF-14 Spear"
    0.0333338588, // "FLAM-40 Flamethrower"
    0.0231700055, // "GL-21 Grenade Launcher"
    0.0216857399, // "GR-8 Recoilless Rifle"
    0.0363380194, // "LAS-98 Laser Cannon"
    0.0233548900, // "LAS-99 Quasar Cannon"
    0.0361037739, // "M-105 Stalwart"
    0.0384311097, // "MG-206 Heavy Machine Gun"
    0.0379053669, // "MG-43 Machine Gun"
    0.0232618030, // "MLS-4X Commando"
    0.0215267718, // "RL-77 Airburst Rocket Launcher"
    0.0366846059, // "RS-422 Railgun"
    0.0419739488, // "TX-41 Sterilizer"
    0.0254831408, // "StA-X3 W.A.S.P. Launcher"
    0.0369922308, // "CQC-1 One True Flag"
    0.0353891367, // "GL-52 De-Escalator"
    0.0389289498, // "Plas-45 Epoch"
    0.0338681461, // "MS-11 Solo Silo"
    0.0296615071, // "EAT-700 Expendable Napalm"
    0.0233839879, // "S-11 Speargun"
    0.0379339790, // "CQC-9 Defoliation Tool"
    0.0364636923, // "M-1000 Maxigun"
    0.0215464040, // "GL-28 Belt-Fed Grenade Launcher"
    0.0256347296, // "EAT-411 Leveller"
    0.0387626408, // "CQC-20 Breaching Hammer"
    0.0216970753, // "B/MD C4 Pack"
    0.0354081263, // "B/FLAM-80 Cremator"
    0.0276929782, // "MGX-42 Bullet Storm"
  ],
  // Backpack slot only (wiki Equipment Traits § Backpack). Not deployables; no mission-only items.
  "BackpackStratagems": [
    "AC-8 Autocannon",
    "AX/AR-23 Guard Dog",
    "AX/TX-13 Guard Dog Dog Breath",
    "AX/LAS-5 Guard Dog Rover",
    "B-1 Supply Pack",
    "FAF-14 Spear",
    "GR-8 Recoilless Rifle",
    "LIFT-850 Jump Pack",
    "RL-77 Airburst Rocket Launcher",
    "SH-20 Balistic Shield Backpack",
    "SH-32 Shield Generator Pack",
    "SH-51 Directional Shield",
    "StA-X3 W.A.S.P. Launcher",
    "B-100 Portable Hellbomb",
    "LIFT-860 Hover Pack",
    "AX/ARC-3 Guard Dog K-9",
    "LIFT-182 Warp Pack",
    "M-1000 Maxigun",
    "AZ/FLAM-75 Guard Dog Hot Dog",
    "B/MD C4 Pack",
    "GL-28 Belt-Fed Grenade Launcher",
    "B/FLAM-80 Cremator",
  ],
  "SupportWeaponStratagems": [
    "AC-8 Autocannon",
    "APW-1 Anti-Material Rifle",
    "ARC-3 Arc Thrower",
    "EAT-17 Expendable Anti-Tank",
    "FAF-14 Spear",
    "FLAM-40 Flamethrower",
    "GL-21 Grenade Launcher",
    "GR-8 Recoilless Rifle",
    "LAS-98 Laser Cannon",
    "LAS-99 Quasar Cannon",
    "M-105 Stalwart",
    "MG-206 Heavy Machine Gun",
    "MG-43 Machine Gun",
    "MLS-4X Commando",
    "RL-77 Airburst Rocket Launcher",
    "RS-422 Railgun",
    "TX-41 Sterilizer",
    "StA-X3 W.A.S.P. Launcher",
    "CQC-1 One True Flag",
    "GL-52 De-Escalator",
    "Plas-45 Epoch",
    "MS-11 Solo Silo",
    "EAT-700 Expendable Napalm",
    "S-11 Speargun",
    "CQC-9 Defoliation Tool",
    "M-1000 Maxigun",
    "GL-28 Belt-Fed Grenade Launcher",
    "EAT-411 Leveller",
    "CQC-20 Breaching Hammer",
    "B/MD C4 Pack",
    "B/FLAM-80 Cremator",
    "MGX-42 Bullet Storm",
  ],
  "VehicleStratagems": [
    "EXO-45 Patriot Exosuit",
    "EXO-49 Emancipator Exosuit",
    "EXO-51 Lumberer Exosuit",
    "EXO-55 Breakthrough Exosuit",
    "M-102 Fast Recon Vehicle",
    "M-103 Supply FRV",
  ],
  // OneHandedWeapons: Only support weapons and primary weapons usable with shields. Secondary weapons are always one-handed but handled separately — do NOT add them here.
  "OneHandedWeapons": [
    "MP-98 Knight",
    "SMG-37 Defender",
    "SMG-72 Pummeler",
    "StA-11 SMG",
    "CB-9 Exploding Crossbow",
    "CQC-1 One True Flag",
    "M7S SMG",
    "SMG/FLAM-34 Stoker",
    "SMG-203 Gallant",
  ],
  "MeleeWeapons": [
    "R-2124 Constitution",
    "R-2 Amendment",
    "CQC-19 Stun Lance",
    "CQC-30 Stun Baton",
    "CQC-5 Combat Hatchet",
    "CQC-2 Saber",
    "K-2 Throwing Knife",
    "CQC-1 One True Flag",
    "CQC-42 Machete",
    "CQC-9 Defoliation Tool",
    "CQC-20 Breaching Hammer",
    "CQC-73 Entrenchment Tool",
  ],
  "SmokeWeapons": [
    "G-3 Smoke",
    "Eagle Smoke Strike",
    "Orbital Smoke Strike",
    "G-89 Smokescreen",
  ],
  "SpawnerWeapons": {
    "Terminid": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "TD-220 Bastion MK XVI",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
      ]
    },
    "Automaton": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 110m Rocket Pods",
        "Eagle Napalm Airstrike",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "FAF-14 Spear",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Napalm Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "StA-X3 W.A.S.P. Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
        "MGX-42 Bullet Storm",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
      ]
    },
    "Illuminate": {
      "primary": [
        "CB-9 Exploding Crossbow",
        "R-36 Eruptor"
      ],
      "secondary": [
        "GP-31 Grenade Pistol",
        "P-33 Missile Pistol"
      ],
      "grenade": [
        "G-6 Frag",
        "G-10 Incendiary",
        "G-12 High Explosive",
        "G-13 Incendiary Impact",
        "G-16 Impact",
        "G-123 Thermite",
        "TED-63 Dynamite",
        "G-142 Pyrotech",
        "G-7 Pineapple",
        "G-48 Giga Grenade",
      ],
      "stratagem": [
        "AC-8 Autocannon",
        "Eagle 500kg Bomb",
        "Eagle Airstrike",
        "Eagle Strafing Run",
        "EAT-17 Expendable Anti-Tank",
        "EXO-45 Patriot Exosuit",
        "EXO-49 Emancipator Exosuit",
        "GL-21 Grenade Launcher",
        "GR-8 Recoilless Rifle",
        "LAS-99 Quasar Cannon",
        "MLS-4X Commando",
        "Orbital 120MM HE Barrage",
        "Orbital 380MM HE Barrage",
        "Orbital Walking Barrage",
        "RL-77 Airburst Rocket Launcher",
        "EAT-700 Expendable Napalm",
        "S-11 Speargun",
        "B/MD C4 Pack",
        "GL-28 Belt-Fed Grenade Launcher",
        "EAT-411 Leveller",
        "TD-220 Bastion MK XVI",
        "MGX-42 Bullet Storm",
        "EXO-51 Lumberer Exosuit",
        "EXO-55 Breakthrough Exosuit",
      ]
    }
  }
};

export default conf;
